import React from "react";
import DashboardMetric from "./DashboardMetric";

export default function ActivityMetric({
  compact = false,
  label,
  value,
  detail,
  title,
  icon,
  tone = "text-info bg-info/10",
}: {
  compact?: boolean;
  label: string;
  value: React.ReactNode;
  detail?: string;
  title?: string;
  icon: React.ReactNode;
  tone?: string;
}) {
  if (compact)
    return (
      <div
        className="min-w-0 rounded-lg border border-outline bg-muted-surface/30 px-3 py-3"
        title={title}
      >
        <div className="flex items-center gap-1.5 text-xs text-text-dim">
          <span className={`shrink-0 ${tone}`}>{icon}</span>
          <span>{label}</span>
        </div>
        <p className="mt-2 whitespace-nowrap text-lg font-semibold tabular-nums">{value ?? "—"}</p>
        {detail && <p className="mt-0.5 truncate text-xs text-text-dim">{detail}</p>}
      </div>
    );
  return (
    <div className="rounded-xl border border-outline bg-surface p-5">
      <DashboardMetric
        label={label}
        value={value}
        detail={detail}
        title={title}
        icon={<span className={`inline-flex shrink-0 rounded-full p-2 ${tone}`}>{icon}</span>}
      />
    </div>
  );
}
